export const environment = {
  production: false,
  emulator: false, // set to false if you want to interface with actual firebase resources
  // Custom API domain fronting the `api` Cloud Run service via Firebase Hosting (see ApiUrlsService).
  // Empty => fall back to the cloudfunctions.net URL.
  apiBaseUrl: "https://api-dev.constructioneye.blackmtn.com.au",
  // Maps JS API. mapId is required by AdvancedMarkerElement; DEMO_MAP_ID is Google's placeholder until
  // a real Map ID (with a cloud style hiding POI/transit labels) is created for this project.
  googleMaps: {
    apiKey: "AIzaSyDinXNMng7GwhhFF2jIGso1LE7Mqp8IV14",
    mapId: "DEMO_MAP_ID",
  },
  firebase: {
    apiKey: "AIzaSyBhnKadnphIoovgFREFWiLCbWlr4bEMMcE",
    authDomain: "bmca-ceye-dev.firebaseapp.com",
    projectId: "bmca-ceye-dev",
    region: "australia-southeast1",
    storageBucket: "bmca-ceye-dev.appspot.com",
    messagingSenderId: "828617478247",
    appId: "1:828617478247:web:7604cf997a8990154404c2",
    measurementId: "G-C09YWRR716",
  },
};
